import { PageDataContainer, PageLink } from "../../../_start/layout/core";
import { layoutManagementSubmenu } from "./LayoutManagementData";
import { LayoutManagementPage } from "./LayoutManagementPage";

const breadcrumbs: Array<PageLink> = [
	{
		title: "Home",
		path: "/",
		isActive: false,
	},
	{
		title: "Lay-outbeheer",
		path: "/layout-management",
		isActive: false,
	},
];

export const LayoutManagementWrapper = () => {
	return (
		<>
			<PageDataContainer
				breadcrumbs={breadcrumbs}
				submenu={layoutManagementSubmenu}
			/>
			<LayoutManagementPage />
		</>
	);
};
